import AirDatepicker from 'air-datepicker';

import en from 'air-datepicker/locale/en';
import ptBr from 'air-datepicker/locale/pt-BR';
import ru from 'air-datepicker/locale/ru';

import dayjs from 'dayjs';
import IMask from 'imask';

import Helper from '@/modules/helper';
import I18n from '@/modules/i18n';
import { apply } from '@/modules/mask';

export default class Calendar {
  constructor(options) {
    this.options = options;
  }

  buttons() {
    const today = {
      content: I18n.t('today'),

      onClick: (el) => {
        const date = new Date();

        el.selectDate(date);
        el.setViewDate(date);
      },
    };

    return ['clear', today];
  }

  configuration() {
    // A dialog lives in the top layer, so a datepicker rendered on the body would show up behind it
    const dialog = this.options.field.closest('dialog');

    const options = {
      autoClose: true,
      buttons: this.buttons(),
      ...(dialog && { container: dialog }),
      clear: I18n.t('clear'),
      dateFormat: I18n.t('datepicker.format'),
      isMobile: false,
      locale: this.locale(),

      onSelect: (data) => {
        const el = data.datepicker.$el;

        if (el.dataset.nextFocus) {
          const nextName = this.nextFocusName(el);
          const nextField = document.querySelector(`[name="${nextName}"]`);

          if (nextField) {
            nextField.focus();
          } else {
            console.warn(`[next_focus] Field with name "${nextName}" not found.`);
          }
        }
      },

      showEvent: false,
      timepicker: false,
    };

    return $.extend({}, options, this.options);
  }

  nextFocusName(el) {
    const matches = el.name.match(/\[([^\]]+)\]/g);
    const name = matches ? matches[matches.length - 1].slice(1, -1) : el.name;

    return el.name.replace(name, el.dataset.nextFocus);
  }

  init() {
    const fieldWrapper = this.options.field.parentElement;

    this.datepicker = new AirDatepicker(this.options.field, this.configuration());

    if (fieldWrapper) {
      const button = fieldWrapper.querySelector('svg');

      if (button) {
        button.addEventListener('click', () => this.datepicker.show());
      }
    }

    this.#maskDate(this.options.field);
  }

  locale() {
    return { 'en': en, 'pt-BR': ptBr, 'ru': ru }[I18n.locale];
  }

  static init(options = {}) {
    const wrapper = options.wrapper || document;
    const fields = options.field ? [options.field] : wrapper.querySelectorAll('[data-calendar]');

    for (const field of fields) {
      options.field = field;

      new Calendar(options).init();

      if (options.onEnter) this.#bindEnter(options);
    }
  }

  static #bindEnter(options) {
    options.field.addEventListener('keydown', (evt) => {
      const key = evt.keyCode || evt.which;

      if (key === 13) {
        evt.preventDefault();

        options.onEnter.call(this, options.field);
      }
    });
  }

  #maskDate(el, options = {}) {
    apply(el, {
      blocks: {
        d: {
          from: 1,
          mask: IMask.MaskedRange,
          maxLength: 2,
          to: 31,
        },

        m: {
          from: 1,
          mask: IMask.MaskedRange,
          maxLength: 2,
          to: 12,
        },

        Y: {
          from: 0,
          mask: IMask.MaskedRange,
          maxLength: 2,
          to: 99,
        },
      },

      format(date) {
        return dayjs(date).format(Helper.dateFormat());
      },

      lazy: true,
      mask: Date,

      parse(str) {
        return dayjs(str, Helper.dateFormat());
      },

      pattern: options.pattern || 'd{/}m{/}YY',
    });
  }
}
